import { motion } from "framer-motion";

const PHONE = "38978321872";

export const FloatingChat = () => (
  <motion.div
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-6 right-6 z-[80] flex flex-col items-center gap-3"
  >
    <a
      href={`viber://chat?number=%2B${PHONE}`}
      data-testid="viber-float-button"
      aria-label="Viber"
      title="Viber"
      className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg shadow-black/20 transition-transform duration-300 hover:scale-110"
      style={{ backgroundColor: "#7360F2" }}
    >
      <img src="https://cdn.simpleicons.org/viber/ffffff" alt="Viber" className="w-7 h-7" />
    </a>
    <a
      href={`https://wa.me/${PHONE}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="WhatsApp"
      title="WhatsApp"
      className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg shadow-black/20 transition-transform duration-300 hover:scale-110"
      style={{ backgroundColor: "#25D366" }}
    >
      <img src="https://cdn.simpleicons.org/whatsapp/ffffff" alt="WhatsApp" className="w-7 h-7" />
    </a>
  </motion.div>
);
